import React from 'react'
import { AiResult } from '../../../../../../../models/AiResult'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { HeaderResultEmailButton } from './HeaderResultEmailButton/HeaderResultEmailButton'

interface ResultCardHeaderCRMButtonsProps {
  aiFeature: AiFeature
  aiResult: AiResult
}

export const ResultCardHeaderEmailButtons: React.FC<ResultCardHeaderCRMButtonsProps> = ({ aiFeature, aiResult }) => {
  return (
    <>
      <HeaderResultEmailButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.GMAIL} />
      <HeaderResultEmailButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.OUTLOOK_MAIL} />
    </>
  )
}
